import React from "react";
import { t } from "i18next";

const RangeInput = ({ minValue, maxValue, onMinChange, onMaxChange }) => {
    const handleMinChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '' || inputValue === null || inputValue === undefined) {
            onMinChange('');
            return;
        }
        const value = Number(inputValue);
        if (isNaN(value) || value < 0) {
            onMinChange('');
            return;
        }
        const currentMax = maxValue || '';
        if (!currentMax || value <= Number(currentMax)) {
            onMinChange(value);
        }
    };

    const handleMaxChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '' || inputValue === null || inputValue === undefined) {
            onMaxChange('');
            return;
        }
        const value = Number(inputValue);
        if (isNaN(value) || value < 0) {
            onMaxChange('');
            return;
        }
        const currentMin = minValue || '';
        if (!currentMin || value >= Number(currentMin)) {
            onMaxChange(value);
        }
    };

    return (
        <div className="flex items-center gap-2">
            <div className="flex flex-col flex-1 gap-1">
                <span className="text-[11px] text-[#939393] font-medium">{t('from')}</span>
                <input
                    type="number"
                    className="w-full border border-[#EDEDED] rounded-lg px-3 py-2 text-[13px] text-[#222222] focus:outline-none focus:ring-2 focus:ring-[#147F26]/40 focus:border-[#147F26] transition-colors"
                    value={minValue || ''}
                    onChange={handleMinChange}
                    placeholder="0"
                    min="0"
                />
            </div>
            <div className="w-3 h-[1px] bg-[#CCCCCC] mt-4 shrink-0" />
            <div className="flex flex-col flex-1 gap-1">
                <span className="text-[11px] text-[#939393] font-medium">{t('to')}</span>
                <input
                    type="number"
                    className="w-full border border-[#EDEDED] rounded-lg px-3 py-2 text-[13px] text-[#222222] focus:outline-none focus:ring-2 focus:ring-[#147F26]/40 focus:border-[#147F26] transition-colors"
                    value={maxValue || ''}
                    onChange={handleMaxChange}
                    placeholder="∞"
                    min="0"
                />
            </div>
        </div>
    );
};

export default RangeInput;
